import { GlobalBaseData } from "@sphtech/dmg-design-system";
import { TSuccessResponse } from "@sphtech/web2-core/ssr";
import { useMatches, useRouteLoaderData } from "react-router";

export function useRouteData() {
  const matches = useMatches();

  // The last item in the array is the current leaf route
  const currentRoute = matches[matches.length - 1];
  const routeId = currentRoute?.id ?? matches[0]?.id ?? "home";

  const globalData =
    useRouteLoaderData<TSuccessResponse<GlobalBaseData> | null>(
      routeId,
    )?.payload;

  // Hydration is disabled for static error pages
  const includeScripts = matches.every((match) => {
    const handle = match.handle as { hydrate?: boolean } | undefined;
    return handle?.hydrate ?? true;
  });

  return { globalData, includeScripts };
}
